import { useWorkItemStatusCounts } from '../../../hooks/queries/useWorkItemStatusCounts';
import { useSidePanel } from '../../../providers/SidePanelProvider';

import FloatingAssistantPillBase from './FloatingAssistantPillBase';

/**
 * The floating assistant pill as `HomeScene` mounts it at the `sheet` site.
 *
 * Counts the household's ACTIVE alerts from the filterless status counts the
 * bell polls, so the pill rides that poll rather than running one of its own.
 * The hook is zero-filled until its first answer and holds the last one while
 * an evicted read refetches, so a read in flight or a failed first read shows
 * the neutral pill and a work-item write never flashes it. With alerts, a tap
 * opens the sheet onto the truncated card whatever the card was left in;
 * without, it opens the sheet as it was.
 */
const FloatingAssistantPill = () => {
  const { isAlertsEnabled, showAssistant, showAssistantOntoAlerts } = useSidePanel();
  const { counts } = useWorkItemStatusCounts({ skip: !isAlertsEnabled });
  const alertCount = counts.active;

  return (
    <FloatingAssistantPillBase
      alertCount={alertCount}
      onOpen={alertCount > 0 ? showAssistantOntoAlerts : showAssistant}
    />
  );
};

export default FloatingAssistantPill;
